// The popup.js 
$ = jQuery;

jQuery(document).ready(function(){

	var windowWidth = $(window).width();
	var windowHeight = $(window).height();

    if($('#subscribe-popup').length > 0 &&  $('#subscribe-popup').hasClass('show-popup')) {
        $.magnificPopup.open({
            items: {
                src: '#subscribe-popup',
                type: 'inline'
            }
        }, 0);
    }
    $('.js-subscribe-popup').click(function() {
        $.magnificPopup.open({
            items: {
                src: '#subscribe-popup',
                type: 'inline'
            }
        }, 0);
    });

	$('.btn__closeup').click(function (e) {
		$('.content-popup').remove();
		$('.knowmore').css('display','none');
	});

// -----------------------------------------------
	$('.more_info').click(function (e){
        $.magnificPopup.open({
            items: {
                src: '.knowmore',
                type: 'inline'
            }
        }, 0);
	})

    $('[data-gallery-link]').click(function(){
        var id = $(this).attr('data-gallery-link');
        $('[data-gallery-id='+id+']').magnificPopup('open');
    });
	
	$('.js-popup-gallery-photo').click(function(){
		$('.modal-gallery-photo').toggleClass('invisible');
    });
	
	$('.js-popup-gallery-video').click(function(){
		$('.modal-gallery-video').toggleClass('invisible');
    });
	
	$('.js-popup-close').click(function(){
		$('.modal-gallery').addClass('invisible');
    });

});